
var close_sticky = document.querySelector('.close-btn');

if(close_sticky){
close_sticky.addEventListener('click', removeSticky);
}

function removeSticky(event){
    var stickyu_part = document.querySelector('.sticky-part');
    stickyu_part.remove();
}

class SlideshowsComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="Slider-"]');
  
      if (!this.slider) return;
  
      this.initPages();
  
      const resizeObserver = new ResizeObserver((entries) => this.initPages());
      resizeObserver.observe(this.slider);
    }
  
    initPages() {
      const sliderActive = this.slider.id;
      const slick = $('#' + sliderActive);
  
      slick.not(".slick-initialized")
        .slick({
          prevArrow:
            '<div class="prev"><svg width="25" height="40" viewBox="0 0 25 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 3L5 20L22 37" stroke="#ffffff" stroke-width="6" stroke-linecap="round"/></svg></div>',
          nextArrow:
            '<div class="next"><svg width="25" height="40" viewBox="0 0 25 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 37L20 20L3 3" stroke="#ffffff" stroke-width="6" stroke-linecap="round"/></svg></div>',
        });

    }
  }
  
customElements.define("slideshows-component", SlideshowsComponent);




$(function () {
    "use strict";

        $(".marquee").marquee({
          direction: "left",
          css3easing: "linear",
          easing: "linear",
          delayBeforeStart: 0,
          duration: 15000,
          gap: 50,
          pauseOnHover: true
        });
     
    

    
      document.addEventListener("shopify:section:load", function (event) {
      
        $(".marquee").marquee({
            direction: "left",
            css3easing: "linear",
            easing: "linear",
            delayBeforeStart: 0,
            duration: 15000,
            gap: 50,
            pauseOnHover: true
          });
       
      });
    
      document.addEventListener("shopify:block:select", function (event) {
    
        $(".marquee").marquee({
            direction: "left",
            css3easing: "linear",
            easing: "linear",
            delayBeforeStart: 0,
            duration: 15000,
            gap: 50,
            pauseOnHover: true
          });
       
      });





      var qsRegex;
      var filterValue;
      // init Isotope
      var $grid = $(".blog-post-grid").isotope({
        itemSelector: ".blog-grid-item",
        layoutMode: "fitRows",
        filter: function() {
          var $this = $(this);
          var searchResult = qsRegex ? $this.text().match(qsRegex) : true;
          var selectResult = filterValue ? $this.is(filterValue) : true;
          return searchResult  && selectResult;
        }
      });
      

      $(".city-filter").on("change", function() {
        filterValue = $(this).val();
        console.log(filterValue);
        $grid.isotope();
      });
      $(".room-filter").on("change", function() {
        filterValue = $(this).val();
        console.log(filterValue);
        $grid.isotope();
      });





      var createMap = function( coords, zoom ) {
        var coordsParts = coords.split( "," );
        if( typeof google !== "undefined" ) {
          var options = {
            zoom: zoom,
            center: new google.maps.LatLng( coordsParts[0], coordsParts[1] ),
            mapTypeId: google.maps.MapTypeId.ROADMAP
          };
            
          var map = new google.maps.Map( document.getElementById( "map" ), options );
            
          var marker = new google.maps.Marker({
            position: new google.maps.LatLng( coordsParts[0], coordsParts[1] ),
            map: map,
            icon:'https://cdn.shopify.com/s/files/1/0812/4917/3780/files/pin.svg?v=1692730544'
          });
      
        }
      
      };


      var map = $('#map');

    var coords = map.data( "coords" );
    var zoom = map.data( "zoom" ) ;

      createMap( coords, zoom)

      
    
     

});

$(document).ready(function(){
  $('.comment-btn').on('click', function(){
    $(this).addClass('hide');
    $('.comment-form').fadeIn();
  })

  $('.cancel').on('click', function(){
    $('.comment-btn').removeClass('hide');
    $('.comment-form').fadeOut();
  })

  // load more products 
	$(".blog-items .article-item").slice(0, 8).show();
  $(".view_more").on('click', function (e) {
      e.preventDefault();
      $(".article-item:hidden").slice(0, 8).slideDown();
      var product_length = $(this).parent().find(".article-item:hidden").length;
      if (product_length == 0) {			
          $(".view_more").fadeOut('slow');
      }
  
  });
  console.log('Test');

})

